
import { Component, Input } from '@angular/core';
import {EntityTypeDefaultImageEnum} from '../../../Misc/enums/entity-type-default-image.enum';

@Component({
    selector: 'agpr-journodex-entity-list-item',
    templateUrl: './journodex-entity-list-item.component.html',
    styleUrls: ['./journodex-entity-list-item.component.scss'],
    standalone: false
})
export class JournodexEntityListItemComponent {
    imageDefault = EntityTypeDefaultImageEnum;

    @Input() entity;

    constructor() {}
}
